export const sanitizeText = (text?: string | null): string => {
    if (!text) return '';
    return text.replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;'
    })[char] || char);
};
